import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { GridActions } from '../actions/grid.actions';
import { Grid } from '../../services/model/grid';

export const gridAdapter: EntityAdapter<Grid> = createEntityAdapter<Grid>({
  selectId: (grid: Grid) => grid.id,
});

export interface GridState {
  grids: EntityState<Grid>;
  grid: Grid | null;
}

export const initialGrid: GridState = {
  grids: gridAdapter.getInitialState(),
  grid: null,
};

export const gridFeature = createFeature({
  name: 'grid',
  reducer: createReducer(
    initialGrid,
    on(GridActions.gridsLoaded, (state, { grids }) => ({
      ...state,
      grids: gridAdapter.setAll(grids, state.grids),
    })),
    on(GridActions.gridLoaded, (state, { grid }) => ({
      ...state,
      grid,
    })),
  ),
});
